import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
// import 'hammerjs';
import { bootstrapApplication } from '@angular/platform-browser';
import { ShareAppComponent } from './app/share.app.component';
import { shareAppConfig } from './app/share.app.config';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(ShareAppComponent, shareAppConfig).then(() => {
  // if ('serviceWorker' in navigator && environment.production) {
  //   navigator.serviceWorker.register('/ngsw-worker.js');
  // }
}).catch(err => console.log(err));
